import { render, staticRenderFns } from "./ActualContacts.vue?vue&type=template&id=6161fa62&scoped=true"
import script from "./ActualContacts.vue?vue&type=script&lang=js"
export * from "./ActualContacts.vue?vue&type=script&lang=js"
import style0 from "./ActualContacts.vue?vue&type=style&index=0&id=6161fa62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6161fa62",
  null
  
)

export default component.exports